import { Meteor } from 'meteor/meteor';
import { Accounts } from 'meteor/accounts-base';

import React from 'react';
import { Router, Link, browserHistory } from 'react-router';

import MgfForm from '../common/mgfForm';
import { TextField, SubmitField } from 'uniforms-bootstrap3';
import { PlaceSchema, Places } from '../../collections/flights/places';

import {
  BPanel,
  Table,
  Button,
  Form,
  FormGroup,
  Col,
  Checkbox,
  ControlLabel,
  FormControl,
  Breadcrumb,
  BreadcrumbItem
} from '@sketchpixy/rubix';

export default class PlaceEditPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};

		if (this.props.params.id)
			this.place = Places.findOne({_id: this.props.params.id});
		else
			this.context.router.push('/places');
	}

	handleSubmit(doc) {
		this.context.router.push('/places');
	}

	render() {
		return (
			<div>
				<Breadcrumb>
					<Breadcrumb.Item>
						<Link to="/places">Lieux d'envols</Link>
					</Breadcrumb.Item>
					<Breadcrumb.Item href="#" active>
						Modifier un lieu d'envol
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Modifier un lieu d'evol">
					<MgfForm schema={PlaceSchema} collection={Places} model={this.place} onSubmit={this.handleSubmit.bind(this)} />
				</BPanel>
			</div>
		);
	}
}

PlaceEditPage.contextTypes = {
  router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/places/PlaceEdit.page.js
 **/